import React from 'react';
import styled from 'styled-components';
import { Release } from "types/release";
import { Cover } from './Cover';
import { ReleaseArtists } from './ReleaseArtists';
import { GenreInfo } from './GenreInfo';
import { CreateReleaseDate } from './CreateReleaseDate';
import { ReleaseCode } from './ReleaseCode';
import { Status } from "./Status";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { useNavigate } from "react-router-dom";

interface TileViewProps {
  data: Release[];
  currentPage: number;
  pageCount: number;
  total: number;
  onPageChange?: (event: PaginatorPageChangeEvent) => void;
}

export const TileView: React.FC<TileViewProps> = props => {
  const { data } = props;
  const navigate = useNavigate();
  return (
    <Container>
      <Grid>
        {data.map((release: Release) => (
          <Card
            key={release.id}
            role="button"
            tabIndex={0}
            onClick={() => navigate(`/releases/${release.id}`)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") navigate(`/releases/${release.id}`);
            }}
          >
            <Cover cover={release.cover_url} height="260px" width="100%" />
            <ReleaseArtistsWrapper>
              <ReleaseArtists release={release.title} artists={release.artists} />
              <Status status={release.status} />
            </ReleaseArtistsWrapper>
            <GenreInfo genres={release.genres} />
            <CreateReleaseDate createdAt={release.created_at} releaseDate={release.release_date} />
            <ReleaseCode id={release.id} ean={release.ean} />
          </Card>
        ))}
      </Grid>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  width: 100%;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 20px;
  background: #F8F8F8;
  border: 1px solid #EEEEEE;
  padding: 12px 14px;
  cursor: pointer;

  &:hover {
    border-color: rgba(103, 119, 255, 0.5);
  }

  &:focus-visible {
    outline: 2px solid rgba(103, 119, 255, 0.7);
    outline-offset: 2px;
  }
`;

const ReleaseArtistsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
`;

// paginator is rendered by parent (`Releases/index.tsx`)
